import { render } from "./MarketsScreen.vue?vue&type=template&id=3a66488c&scoped=true"
import script from "./MarketsScreen.vue?vue&type=script&lang=js"
export * from "./MarketsScreen.vue?vue&type=script&lang=js"

import "./MarketsScreen.vue?vue&type=style&index=0&id=3a66488c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a66488c"]])

export default __exports__